import React, { useState } from "react";
import { motion } from "framer-motion";

export default function SoundVibration({ onComplete }) {
  const [vibrating, setVibrating] = useState(false);
  const [frequency, setFrequency] = useState(4); // waves per second
  const [amplitude, setAmplitude] = useState(10);

  const waveDuration = 1 / frequency; // animation timing

  return (
    <div className="flex flex-col items-center mt-10">
      <h2 className="text-2xl font-bold text-purple-700 mb-6">
        Sound Produced by Vibrations
      </h2>

      {/* EXPERIMENT AREA */}
      <div className="relative w-[600px] h-[240px] border rounded bg-white shadow overflow-hidden">

        {/* TUNING FORK */}
        <motion.div
          animate={
            vibrating
              ? { rotate: [-5, 5, -5] }
              : { rotate: 0 }
          }
          transition={{
            repeat: Infinity,
            duration: 0.1 + (10 / (frequency * 10))
          }}
          className="absolute left-[60px] top-[40px]"
        >
          <TuningFork />
        </motion.div>

        {/* SOUND WAVES */}
        {vibrating &&
          [...Array(4)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute left-[120px] top-[100px] rounded-full border-2 border-blue-400"
              style={{
                width: amplitude * 4,
                height: amplitude * 4,
                marginLeft: -(amplitude * 2),
                marginTop: -(amplitude * 2)
              }}
              animate={{
                scale: [1, 8],
                opacity: [0.9, 0],
              }}
              transition={{
                repeat: Infinity,
                duration: waveDuration * 3,
                delay: i * (waveDuration)
              }}
            ></motion.div>
          ))}
      </div>

      {/* CONTROLS */}
      <div className="mt-8 w-[520px] p-4 bg-gray-50 rounded shadow">
        
        {/* FREQUENCY */}
        <div className="mb-4">
          <label className="font-semibold">
            Frequency of Vibration: {frequency} Hz
          </label>
          <input
            type="range"
            min="1"
            max="12"
            value={frequency}
            onChange={(e) => {
              setFrequency(+e.target.value);
              onComplete && onComplete();
            }}
            className="w-full"
          />
        </div>

        {/* AMPLITUDE */}
        <div className="mb-4">
          <label className="font-semibold">
            Amplitude (strength of vibration): {amplitude}px
          </label>
          <input
            type="range"
            min="5"
            max="25"
            value={amplitude}
            onChange={(e) => setAmplitude(+e.target.value)}
            className="w-full"
          />
        </div>

        {/* BUTTON */}
        <div className="flex justify-center mt-4">
          <button
            onClick={() => {
              setVibrating(!vibrating);
              onComplete && onComplete();
            }}
            className={`px-6 py-2 rounded text-white ${
              vibrating ? "bg-red-600" : "bg-purple-600"
            }`}
          >
            {vibrating ? "Stop Vibration" : "Start Vibration"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ---------------------- TUNING FORK SVG ---------------------- */

function TuningFork() {
  return (
    <svg width="100" height="160" viewBox="0 0 100 160">
      {/* Left prong */}
      <rect x="20" y="10" width="10" height="80" rx="4" fill="#555" />
      {/* Right prong */}
      <rect x="70" y="10" width="10" height="80" rx="4" fill="#555" />
      {/* Base handle */}
      <rect x="43" y="80" width="14" height="70" rx="4" fill="#777" />
      {/* Connector */}
      <rect x="25" y="70" width="50" height="8" rx="4" fill="#555" />
    </svg>
  );
}
